import moment from "@/services/moment";

// 取得したサービスの営業時間内かの比較
export const isOpenForBusiness = (operation_start_time, operation_end_time) => {
  if (operation_start_time == null) {
    return false;
  }
  var current = new Date();
  var start = moment(
    new Date(
      current.getFullYear(),
      current.getMonth(),
      current.getDate(),
      operation_start_time.split(":")[0],
      operation_start_time.split(":")[1]
    )
  );
  var limit = moment(
    new Date(
      current.getFullYear(),
      current.getMonth(),
      current.getDate(),
      operation_end_time.split(":")[0],
      operation_end_time.split(":")[1]
    )
  );
  // 比較できる形にする為にmomentで再代入
  current = moment(new Date());
  return (
    (current.isBefore(limit) ? true : false) &&
    (current.isAfter(start) ? true : false)
  );
};
